export default __webpack_public_path__ + "ba60cfcb38b04a043e5013908f5164d5.png";